import React from "react";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { getFormValues } from "redux-form";

import { CopyFromAgentOffice, EmailField, GeneralInfoFields } from "components";
import { LineDivider } from "components/layout";
import { UsersGeneralFormProps } from "types";

import styles from "../userForm.module.scss";

const AddUserForm = ({ setFullName, onSubmit }: UsersGeneralFormProps) => {
	const { handleSubmit, watch } = useFormContext();

	const { role: roleValue }: { [key: string]: any } = useSelector(state =>
		getFormValues("addUser.rolePermissions")(state),
	);

	const company = watch("agentOffice");

	return (
		<form
			id="generalInfo"
			className={styles.generalInfo}
			onSubmit={handleSubmit(onSubmit)}
		>
			<EmailField
				isActiveUser
				companyId={company?.id}
				userRole={roleValue}
			/>
			<LineDivider className="w-90" />
			<CopyFromAgentOffice isLoading={false} />
			<GeneralInfoFields setFullName={setFullName} />
		</form>
	);
};

export default AddUserForm;
